import { DialogContext } from '@/contexts';
import { useContext } from 'react';

export const useDialog = () => {
  const ctx = useContext(DialogContext);

  return ctx;
};
